import styled, {css, DefaultTheme} from 'styled-components'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {Button} from '@/components/ui/button/Button'
import {ButtonNavLink} from '@/components/ui/button-nav-link/ButtonNavLink'
import {ButtonLink} from '@/components/ui/button-link/ButtonLink'

export const StyledSidebarWrapper = styled.div(
    ({theme: {palette}}) => css`
        display: grid;
        grid-template-rows: auto 1fr auto;
        border-right: 1px solid ${palette.neutral[200]};
        overflow-y: hidden;
    `
)

export const StyledSidebarHeader = styled.div`
    height: 56px;
`

export const StyledSidebarBody = styled.div`
    overflow-y: auto;
    height: 100%;
`

export const StyledSidebarSlot = styled(Flexbox)<{$fullHeight?: boolean}>(
    ({theme: {spacing}, $fullHeight}) => css`
        padding: ${spacing * 3}px;
        ${$fullHeight &&
        css`
            height: 100%;
        `}
    `
)

export const StyledSidebarNavGroupTitle = styled.span(
    ({theme: {typography, palette, spacing}}) => css`
        ${typography.textSm};
        color: ${palette.neutral[500]};
        padding: 0 ${spacing * 2}px;
        font-weight: 500;
    `
)

export const StyledSidebarButtonsGroup = styled.div(
    ({theme: {spacing}}) => css`
        display: flex;
        flex-direction: column;
        gap: ${spacing * 0.5}px;
        width: 100%;
    `
)

export const StyledSidebarSeparator = styled.div(
    ({theme: {palette}}) => css`
        width: 100%;
        border-bottom: 2px dotted ${palette.neutral[200]};
    `
)

export const makeSidebarButtonBaseStyle = (theme: DefaultTheme, disabled?: boolean) => css`
    width: 100%;
    padding: ${theme.spacing}px ${theme.spacing * 2}px;
    height: 28px;
    justify-content: flex-start;

    ${disabled
        ? css`
              cursor: not-allowed;
          `
        : css`
              cursor: pointer;
          `}
`

export const makeSidebarButtonVariantStyle = (theme: DefaultTheme, disabled?: boolean) => css`
    color: ${theme.palette.neutral['700']};
    box-shadow: none;

    ${!disabled
        ? css`
              &:hover {
                  background: ${theme.palette.neutral['white']}${theme.opacities[70]};
                  color: ${theme.palette.neutral['700']};
              }

              &.active {
                  background: ${theme.palette.neutral.white};
                  box-shadow: ${theme.shadows.xs};
                  color: ${theme.palette.neutral[950]};
              }
          `
        : css`
              color: ${theme.palette.neutral[400]};
          `}
`

export const StyledSidebarButton = styled(Button)(
    ({theme, disabled}) => css`
        ${makeSidebarButtonBaseStyle(theme, disabled)}
        ${makeSidebarButtonVariantStyle(theme, disabled)}
    `
)

export const StyledSidebarButtonNavLink = styled(ButtonNavLink)(
    ({theme, disabled}) => css`
        ${makeSidebarButtonBaseStyle(theme, disabled)}
        ${makeSidebarButtonVariantStyle(theme, disabled)}
    `
)

export const StyledSidebarButtonLink = styled(ButtonLink)(
    ({theme, disabled}) => css`
        ${makeSidebarButtonBaseStyle(theme, disabled)}
        ${makeSidebarButtonVariantStyle(theme, disabled)}
    `
)
